import * as React from "react";
import { forwardRef } from "react";
const SvgGlyphChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M27.121,12.70709,16.70709,23.121a1,1,0,0,1-1.41418,0L4.879,12.70709a1,1,0,0,1,0-1.41418L6.29291,9.879a1,1,0,0,1,1.41418,0L16,18.17188,24.29291,9.879a1,1,0,0,1,1.41418,0L27.121,11.29291A1,1,0,0,1,27.121,12.70709Z" }));
const ForwardRef = forwardRef(SvgGlyphChevronDown);
export default ForwardRef;
